"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getProgressionDescriptionForObjective = void 0;

var _types = require("./types");

var getTranslationKeyForObjective = function getTranslationKeyForObjective(objective) {
  var _objective$userAction = objective.userActionsTypes,
      userActionsTypes = _objective$userAction === void 0 ? [] : _objective$userAction,
      withMedia = objective.withMedia;
  var hasFeedMessage = userActionsTypes === null || userActionsTypes === void 0 ? void 0 : userActionsTypes.includes(_types.UserActionsType.FEED_MESSAGE);
  var hasFeedActivityShare = userActionsTypes === null || userActionsTypes === void 0 ? void 0 : userActionsTypes.includes(_types.UserActionsType.FEED_ACTIVITY_SHARE);
  var hasChallengeSuccess = userActionsTypes === null || userActionsTypes === void 0 ? void 0 : userActionsTypes.includes(_types.UserActionsType.CHALLENGE_SUCCESS);
  var hasReferralSuccess = userActionsTypes === null || userActionsTypes === void 0 ? void 0 : userActionsTypes.includes(_types.UserActionsType.REFERRAL_SUCCESS);
  var hasQuizCompleted = userActionsTypes === null || userActionsTypes === void 0 ? void 0 : userActionsTypes.includes(_types.UserActionsType.QUIZ_COMPLETED);

  if ((hasFeedActivityShare || hasFeedMessage) && withMedia) {
    return 'objectives.progression.user-actions.pictures-shared';
  }

  if (hasFeedMessage) {
    return 'objectives.progression.user-actions.messages-posted';
  }

  if (hasFeedActivityShare) {
    return 'objectives.progression.user-actions.activites-shared';
  }

  if (hasChallengeSuccess) {
    return 'objectives.progression.user-actions.challenges-completed';
  }

  if (hasReferralSuccess) {
    return 'objectives.progression.user-actions.colleages-sponsored';
  }

  if (hasQuizCompleted) {
    return 'objectives.progression.user-actions.quiz-completed';
  }

  return '';
};

var getProgressionLabelForObjective = function getProgressionLabelForObjective(objective) {
  var unit = objective.unit,
      userActionsTypes = objective.userActionsTypes;
  var isPointsObjective = unit === 'points' || objective.minPoints;

  if ((userActionsTypes === null || userActionsTypes === void 0 ? void 0 : userActionsTypes.length) && !isPointsObjective) {
    return getTranslationKeyForObjective(objective);
  }

  if (isPointsObjective) {
    return 'objectives.progression.conditions.points';
  }

  if (unit === 'climb' || objective.minClimb) {
    return "objectives.progression.conditions.climbed";
  }

  if (unit === 'distance' || objective.minDistance) {
    return "objectives.progression.conditions.distance-traveled";
  }

  if (unit === 'descent' || objective.minDescent) {
    return "objectives.progression.conditions.descent";
  }

  return '';
};

var getProgressionDescriptionForObjective = function getProgressionDescriptionForObjective(_ref) {
  var _objective$userAction2;

  var objective = _ref.objective,
      t = _ref.t;

  if (!objective) {
    return '';
  }

  return "".concat(!((_objective$userAction2 = objective.userActionsTypes) === null || _objective$userAction2 === void 0 ? void 0 : _objective$userAction2.length) && (objective === null || objective === void 0 ? void 0 : objective.repeat) ? " x " : "").concat(t(getProgressionLabelForObjective(objective)));
};

exports.getProgressionDescriptionForObjective = getProgressionDescriptionForObjective;
//# sourceMappingURL=getProgressionDescriptionForObjective.js.map